import Delete from "@mui/icons-material/Delete";
import { type GridColDef, type GridRenderCellParams } from "@mui/x-data-grid-pro";

import CoAppDataGridDateTimeCell from "../../../../global/components/datagrid/CoAppDataGridDateTimeCell";
import CoAppDataGridNameCell from "../../../../global/components/datagrid/CoAppDataGridNameCell";
import { CoAppDataGridActionsContainer } from "../../../../global/styled/global.styled";

export const groupIdpGroupColumns = ["actions", "name", "createdAt"];

export interface GroupIdpGroupRow {
	id: string | number;
	name: string;
	createdAt?: string | null;
	[key: string]: unknown;
}

export const getGroupSSOColumns = (
	identityProviderName: string | null,
	removeIdPGroupFromGroup: (idpGroupId: GroupIdpGroupRow["id"]) => void
): GridColDef<GroupIdpGroupRow>[] => [
	{
		field: "name",
		headerName: identityProviderName ? `${identityProviderName} Group` : "Group",
		disableExport: true,
		editable: true,
		sortable: true,
		flex: 1,
		renderCell: (params: GridRenderCellParams<GroupIdpGroupRow>) => (
			<CoAppDataGridNameCell item={params.row} />
		),
	},
	{
		field: "createdAt",
		headerName: "Date Mapped",
		disableExport: true,
		editable: true,
		sortable: true,
		flex: 1,
		valueGetter: (value: string | null) => {
			if (!value) {
				return null;
			}
			return new Date(value);
		},
		renderCell: (params: GridRenderCellParams<GroupIdpGroupRow, Date | null>) => (
			<CoAppDataGridDateTimeCell value={params.value} />
		),
	},
	{
		field: "actions",
		disableExport: true,
		type: "actions",
		flex: .1,
		sortable: false,
		renderCell: (params: GridRenderCellParams<GroupIdpGroupRow>) => (
			<CoAppDataGridActionsContainer>
						<Delete
							onClick={() => {
								removeIdPGroupFromGroup(params.row.id);
							}}
						/>
					</CoAppDataGridActionsContainer>
		),
	},
];
